export const PAGES = {
  HOME: '/',
  CHECKOUT: '/checkout',
} as const;
